/* tslint:disable */
/* eslint-disable */
/* @relayHash 8b5fc42ac08a2093cfc0ebdfda6f4447 */

import { ConcreteRequest } from "relay-runtime";
export type renewMyPinsMutationVariables = {};
export type renewMyPinsMutationResponse = {
    readonly renewMyPins: {
        readonly pins: {
            readonly roomNumber: string | null;
            readonly roomOwnerNumber: string | null;
        } | null;
        readonly errors: ReadonlyArray<{
            readonly key: string;
            readonly message: ReadonlyArray<string | null> | null;
            readonly reason: ReadonlyArray<string | null> | null;
        } | null> | null;
    } | null;
};
export type renewMyPinsMutation = {
    readonly response: renewMyPinsMutationResponse;
    readonly variables: renewMyPinsMutationVariables;
};



/*
mutation renewMyPinsMutation {
  renewMyPins {
    pins {
      roomNumber
      roomOwnerNumber
    }
    errors {
      key
      message
      reason
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "renewMyPins",
    "storageKey": null,
    "args": null,
    "concreteType": "RenewMyPinsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "pins",
        "storageKey": null,
        "args": null,
        "concreteType": "RenewedPins",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "roomNumber",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "roomOwnerNumber",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "errors",
        "storageKey": null,
        "args": null,
        "concreteType": "InputError",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "key",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "message",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "reason",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "renewMyPinsMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "renewMyPinsMutation",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "renewMyPinsMutation",
    "id": null,
    "text": "mutation renewMyPinsMutation {\n  renewMyPins {\n    pins {\n      roomNumber\n      roomOwnerNumber\n    }\n    errors {\n      key\n      message\n      reason\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '14130d3669c2342b436460024398fb71';
export default node;
